import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'hours',
  standalone: true,
})
export class HoursPipe implements PipeTransform {
  transform(value: number): string {
    const negative = value < 0;
    value = Math.abs(value);
    const hours = Math.floor(value);
    const multiple = hours > 1;
    const hoursBlock = `${negative ? '- ' : ''}${hours} heure${multiple ? 's' : ''}`;

    const minutes = (value - hours) * 60;
    let minutesBlock = '';
    if (minutes > 0) {
      minutesBlock = ` ${Math.round(minutes)} minutes`;
    }
    return `${hoursBlock}${minutesBlock}`;
  }
}
